export const DASHBOARD_DATA = 'DASHBOARD_DATA';
export const AVAILABLE_REPORTS = 'AVAILABLE_REPORTS';
export const CURRENT_CYCLE = 'CURRENT_CYCLE';
